import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CalendarAppointment } from "@/hooks/useCalendarData";
import { RescheduleConfirmContent, Conflict, Warning } from "./RescheduleConfirmContent";

export interface RescheduleConfirmViewProps {
  appointment: CalendarAppointment;
  customerHasEmail?: boolean;
  newStartTime: Date;
  newEndTime: Date;
  timeZone?: string;
  teamMemberName?: string;
  conflicts: Conflict[];
  warnings: Warning[];
  sendNotification: boolean;
  onSendNotificationChange: (value: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  originalStartTime?: Date;
  originalEndTime?: Date;
}

export const RescheduleConfirmView = ({
  appointment,
  customerHasEmail = true,
  newStartTime,
  newEndTime,
  timeZone,
  teamMemberName,
  conflicts,
  warnings,
  sendNotification,
  onSendNotificationChange,
  onConfirm,
  onCancel,
  originalStartTime,
  originalEndTime,
}: RescheduleConfirmViewProps) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-background">
      {/* Header */}
      <div className="bg-card border-b border-border px-4 py-3 flex items-center gap-3 flex-shrink-0">
        <Button
          variant="ghost"
          size="icon"
          onClick={onCancel}
          className="flex-shrink-0"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div className="flex-1 min-w-0 flex items-center gap-2">
          <Calendar className="h-5 w-5 flex-shrink-0" />
          <h1 className="font-semibold text-lg truncate">
            {t('confirmReschedule')}
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <RescheduleConfirmContent
          appointment={appointment}
          customerHasEmail={customerHasEmail}
          newStartTime={newStartTime}
          newEndTime={newEndTime}
          timeZone={timeZone}
          teamMemberName={teamMemberName}
          conflicts={conflicts}
          warnings={warnings}
          sendNotification={sendNotification}
          onSendNotificationChange={onSendNotificationChange}
          onConfirm={onConfirm}
          onCancel={onCancel}
          originalStartTime={originalStartTime}
          originalEndTime={originalEndTime}
        />
      </div>
    </div>
  );
};
